export const BACKGROUND_CHECK_DESCRIPTION =
  "Screen contractors and mitigate risk by requesting a comprehensive background check. This allows you to securely review criminal or employment history for security-sensitive roles and regulatory compliance.";
export const BACKGROUND_CHECK_EXAMPLE_USE_CASES =
  "Security-sensitive roles, regulatory compliance, risk mitigation for client-facing positions.";
export const BACKGROUND_CHECK_COST = "Variable (Request more info)";

export const BACKGROUND_CHECK = {
  description: BACKGROUND_CHECK_DESCRIPTION,
  exampleUseCases: BACKGROUND_CHECK_EXAMPLE_USE_CASES,
  cost: BACKGROUND_CHECK_COST
};
